// import store, { modulesName } from "@/store";

export const checkPermissionGuard = (to, from, next) => {
  //TODO: Implement checkPermissionGuard
  return next();
};
